export default __webpack_public_path__ + "static/media/user.3b526e71.svg";